import { Observable, of } from "rxjs"
import { switchMap, catchError } from "rxjs/operators"
import { ofType, StateObservable } from "redux-observable"
import type { EpicDependencies } from "../../rxjs/configureEpics"
import { getHttpHeaders } from "../../auth/selectors"
import { getDownloadReportQueryApiParam } from "./selectors"
import { DOWNLOAD_REPORT, downloadReportFailure, downloadReportSuccess } from "./actions"
import { mapAgendaNameToApiRoute } from "./utils"
import { getCurrentPath } from "../../router/selectors"
import { getOrdersQueryApiParam } from "./orders/selectors"
import { isTimesheetReportAgendaOpened } from "./timesheet/selectors"
import { isTransactionsReportAgendaOpened } from "./transactions/selectors"
import { isCustomerFeedbackAgendaOpened, isCustomerReportAgendaOpened } from "./customers/customersTable/selectors"
import { logger } from "../../../utils/loggerWrap"
import { Action, StateObject } from "../../redux/types"

export const downloadReportRequested = (
    actions$: Observable<Action>,
    _state$: StateObservable<StateObject>,
    deps: EpicDependencies
) =>
    actions$.pipe(
        ofType(DOWNLOAD_REPORT),
        switchMap((action: Action) => {
            const currentPath = getCurrentPath(deps.getState())

            logger.info("downloadReportRequested - download export", {
                data: action.payload,
                currentPath: currentPath,
            })

            if (currentPath.query && currentPath.query.tab && currentPath.query.tab === "orders") {
                return deps.api
                    .getOrdersCsvReportApi(getHttpHeaders(deps.getState()), getOrdersQueryApiParam(deps.getState()))
                    .pipe(
                        switchMap(() => {
                            return [downloadReportSuccess()]
                        }),
                        catchError(error => of(downloadReportFailure(error)))
                    )
            }

            const downloadParameters = getDownloadReportQueryApiParam(
                deps.getState(),
                action.payload.reportAgenda,
                action.payload.exportType
            )

            if (!downloadParameters) {
                return []
            }

            // FIX for these three reports, will be fixed on backend later
            let csvAgendaName = mapAgendaNameToApiRoute(action.payload.reportAgenda)

            if (
                isTimesheetReportAgendaOpened(deps.getState()) ||
                isTransactionsReportAgendaOpened(deps.getState()) ||
                (isCustomerReportAgendaOpened(deps.getState()) && !isCustomerFeedbackAgendaOpened(deps.getState()))
            ) {
                csvAgendaName = `${csvAgendaName}/download`
            }

            return deps.api.downloadReport(getHttpHeaders(deps.getState()), csvAgendaName, downloadParameters).pipe(
                switchMap(() => {
                    return [downloadReportSuccess()]
                }),
                catchError(error => of(downloadReportFailure(error)))
            )
        })
    )
export default [downloadReportRequested]
